import React, { useEffect, useState } from 'react';
import servicesPricing      from 'pursuit/config/servicesPricing';
import scrollToComponent    from 'react-scroll-to-component';

export default function PricingJumpTo(props) {
    const { scrollReferences } = props;
    const [options, setOptions] = useState([]);

    useEffect(() => {
        let tmpOptions = [];

        Object.keys(servicesPricing).map((serviceType, key) => {
            tmpOptions.push({
                label: serviceType,
                value: ''
            });

            Object.keys(servicesPricing[serviceType]).map((section, key) => {
                tmpOptions.push({
                    label: '&nbsp;&nbsp;&nbsp;&nbsp;'+section,
                    value: ''
                });

                servicesPricing[serviceType][section].map((service, key) => {
                    tmpOptions.push({
                        label: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+service.label,
                        value: service.slug
                    });
                });
            });

            tmpOptions.push({
                label: '',
                value: ''
            });
        });

        tmpOptions.pop();

        setOptions(tmpOptions);
    }, []);

    return (
        <select
            onChange={(event) => {
                scrollToComponent(
                    scrollReferences[event.target.value], {
                        offset: -100,
                        align: 'top',
                        duration: 300,
                    }
                );
            }}
        >
            <option value="">Jump To ...</option>
            {options.map((item, key) => {
                return (
                    <option
                        key={key}
                        value={item.value}
                        dangerouslySetInnerHTML={{__html: item.label}}
                    />
                )
            })}
        </select>
    )
};
